import changeLanguage from './lang';
import scroll from './scroll';
import firstTime from './firstTime';

const Actions = { changeLanguage, scroll, firstTime };

export default Actions;